<template>
    <div>
        <button
            @click="changeView(1)"
            type="button"
            class="btn btn-outline-primary my-2"
        >
            Volver
        </button>
        <h1>Show</h1>
        <pre>{{ categories }}</pre>
    </div>
</template>
<script>
export default {
    props: {
        contestId: Number,
    },
    data() {
        return {
            categories: [],
        };
    },
    methods: {
        changeView(page) {
            this.$emit("change", page);
        },
        getModel() {
            let me = this;
            axios
                .get(`/api/admin-category/judge/6518?type=internal`)
                .then(function (response) {
                    const { categories } = response.result;
                    me.categories = categories;
                })
                .catch(function (error) {});
        },
    },
    mounted() {
        let me = this;
        me.getModel();
    },
};
</script>
